export default __webpack_public_path__ + "static/media/Vector7.f9cec4cf.svg";